// Source badge content for imported playlists: the DJ app's mark as a
// normalised bitmap (square, tight-cropped, centred, black-on-alpha, 64px —
// an exact 4x of the 16px slot so downscaling is uniform).
import React from 'react';
import rekordbox from '../assets/source-glyph-rekordbox.png';
import serato from '../assets/source-glyph-serato.png';
import traktor from '../assets/source-glyph-traktor.png';
import virtualdj from '../assets/source-glyph-virtualdj.png';

export const SOURCE_LABELS = { rekordbox: 'Rekordbox', serato: 'Serato', traktor: 'Traktor', virtualdj: 'Virtual DJ' };
const SRC = { rekordbox, serato, traktor, virtualdj };

export function SourceGlyph({ source, size = 16, className }) {
    const src = SRC[source];
    if (!src) return null;
    // Two rules keep the badge reading centred on EVERY monitor/zoom combo
    // (it looked fine on one machine and lopsided on another before):
    //
    // 1. Whole-device-pixel SIZE. At fractional devicePixelRatios (110% app
    //    zoom on a 1x monitor → dpr ≈ 1.095) a 16px glyph spans 17.5 device
    //    pixels, so its two edges resample with different AA phase — the
    //    thin outline ring around the mark then renders thicker on one side.
    //    Snapping the bitmap to an integer device size keeps both edges in
    //    the same phase, so the ring stays even wherever the badge lands.
    // 2. Transform centring (not flex): flex snaps the box to whole CSS
    //    pixels and pushes the leftover to one side; translate(-50%,-50%)
    //    splits it evenly with sub-pixel precision. The parent badge is
    //    position: absolute, so it is the containing block.
    const dpr = window.devicePixelRatio || 1;
    const snapped = Math.max(1, Math.round(size * dpr)) / dpr;
    return <img src={src} alt="" width={size} height={size} className={className} draggable={false} style={{
        display: 'block', width: snapped, height: snapped,
        position: 'absolute', left: '50%', top: '50%',
        transform: 'translate(-50%, -50%)',
    }} />;
}
